
export const SET_AGUARDAR = 'SET_AGUARDAR';

export const setAguardar = valor=>({
    type: SET_AGUARDAR,
    value: valor,
});